export default __webpack_public_path__ + "static/pt-BR-cb934e54c6998d0606cbc1c224903e4c.svg";